module.exports = __webpack_public_path__ + "static/media/anc2kz.0d7b2cc3.pdf";